import SlidesSection from './SlidesSection';

export default SlidesSection;
